import React from "react";

export const MILESTONES = [
  { min: 10, label: "Top Referrer", color: "bg-yellow-50 text-yellow-800 border-yellow-200" },
  { min: 5, label: "Ambassador", color: "bg-purple-50 text-purple-800 border-purple-200" },
  { min: 3, label: "Advocate", color: "bg-indigo-50 text-indigo-800 border-indigo-200" },
  { min: 1, label: "Starter", color: "bg-blue-50 text-blue-800 border-blue-200" },
];

export function milestoneFor(count) {
  return MILESTONES.find((m) => count >= m.min) || null;
}

export default function ReferralBadge({ count, className = "" }) {
  const m = milestoneFor(count);
  if (!m) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[10px] font-semibold border ${m.color} ${className}`}
      data-testid={`referral-badge-${m.label.toLowerCase().replace(/\s+/g, "-")}`}
    >
      {m.label}
    </span>
  );
}
